<template>

  <div id="border-left-alert" ref="alertDiv">
    <slot>

    </slot>
  </div>

</template>

<script setup>

</script>

<style lang="scss" scoped>
#border-left-alert {
  border-radius: 16px;
  top: 40%;
  width:426px;
  left: calc(50% - 213px);
  position: fixed;

  color: white;
  background: rgba(0, 0, 0, 0.40);
  display: flex;
  flex-direction: column;

  padding: 24px 45px 32px 32px;
  box-sizing: border-box;
  z-index: 999;

  font-family: Arial;
  font-size: 33px;
  font-weight: 700;
  line-height: 42px; /* 129.167% */
  letter-spacing: -0.661px;
  justify-content: center;
  align-items:center;


}

</style>